import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the schedule routes a "Schedules" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/schedules')({
  staticData: { crumb: 'common:nav.schedules' },
  component: Outlet,
});
